<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>
          <div class="col-md-10">
            <div class="mb-2 animated fadeIn">
              <ng-container *ngIf="isTocSite">
                <card-section-header
                  title="Check in workers to site:"
                  icon="fas fa-pen-to-square">
                </card-section-header>
              </ng-container>
              <ng-container *ngIf="!isTocSite">
                <card-section-header
                  title="Check in workers"
                  icon="fas fa-pen-to-square">
                </card-section-header>
              </ng-container>
              <div class="sl-accordion work-order-accordion">
                <div>

                  <sl-accordion-section *ngIf="!isTocSite" title='Work Order / Site Session'>
                    <ng-container *ngIf="this.workOrder || isSiteSession">
                      <div>
                        <a href="javascript:void(0)" (click)="editWorkOrder()">change</a>
                      </div>
                      <br>
                    </ng-container>
                    <ng-container *ngIf="!workOrder && !isSiteSession">
                      <div>
                        <button type="button" class="btn btn-round btn-sm btn-primary" (click)="editWorkOrder()" [disabled]="isSiteLoading">Choose</button>
                        <span *ngIf="isSiteLoading" class="small-spinner-inline">
                          <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                        </span>
                        <span *ngIf="workOrderLoading" class="small-spinner-inline">
                          <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                        </span>
                      </div>
                      <p *ngIf="workOrderError" class="small-data d-block mb-2 text-danger">Could not load work order</p>
                    </ng-container>

                    <ng-container *ngIf="workOrder">
                      <div class="title-and-badge-wrapper">
                        <a [routerLink]="['/', routeRole, 'sites', selectedSiteId, 'work-orders', workOrder.id]">
                          <h6>WRK{{ workOrder.id }}</h6>
                        </a>
                        <work-order-state-badge *ngIf="workOrder" [workOrder]="workOrder"></work-order-state-badge>
                      </div>
                      <p>
                        {{ workOrder.description }}
                      </p>

                      <p>
                        <i *ngIf="!workOrder.asset.locked" class="fas fa-unlock color_green-shade1"></i>
                        <i *ngIf="workOrder.asset.locked" class="fas fa-lock color_red-shade1"></i>
                        &nbsp;
                        <a class="under-row" [routerLink]="['/' + routeRole, 'sites', selectedSiteId, 'assets', workOrder.asset.id ]">{{ workOrder.asset.name }}</a>
                      </p>
                      <p>
                        {{ workOrder.asset.description }}
                      </p>
                      <p *ngFor="let category of workOrder.asset.assetCategories">
                        <span class="badge badge-pill badge-primary" [ngStyle]="{ 'background-color': category.color }">{{category.name}}</span>
                      </p>
                      <div *ngIf="workOrder.asset.restrictions.length">
                        <ng-container *ngFor="let item of (showAllAssetRestrictions ? workOrder.asset.restrictions : (workOrder.asset.restrictions | slice:0:restrictionsPreviewCount))">
                          <p class="asset-restriction"><i class="fas fa-exclamation-triangle">&nbsp;</i>{{ item.description }}</p>
                        </ng-container>
                        <button
                          *ngIf="workOrder.asset.restrictions.length > restrictionsPreviewCount"
                          type="button"
                          class="btn btn-link btn-sm p-0 mb-2 d-block text-left"
                          (click)="showAllAssetRestrictions = !showAllAssetRestrictions">
                          <i class="fas" [ngClass]="showAllAssetRestrictions ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                          &nbsp;{{ showAllAssetRestrictions ? 'Show less' : ('Show all (' + workOrder.asset.restrictions.length + ')') }}
                        </button>
                      </div>
                      <div *ngIf="workOrder.asset.site.restrictions.length">
                        <ng-container *ngFor="let item of (showAllSiteRestrictions ? workOrder.asset.site.restrictions : (workOrder.asset.site.restrictions | slice:0:restrictionsPreviewCount))">
                          <p class="asset-restriction"><i class="fas fa-exclamation-triangle">&nbsp;</i>{{ item.description }}</p>
                        </ng-container>
                        <button
                          *ngIf="workOrder.asset.site.restrictions.length > restrictionsPreviewCount"
                          type="button"
                          class="btn btn-link btn-sm p-0 mb-2 d-block text-left"
                          (click)="showAllSiteRestrictions = !showAllSiteRestrictions">
                          <i class="fas" [ngClass]="showAllSiteRestrictions ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                          &nbsp;{{ showAllSiteRestrictions ? 'Show less' : ('Show all (' + workOrder.asset.site.restrictions.length + ')') }}
                        </button>
                      </div>
                      <ng-container *ngIf="workOrderCompetenciesLoading || workOrderCompetenciesError || workOrderCompetencies.length">
                        <div *ngIf="workOrderCompetenciesLoading" class="mt-4">
                          <skeleton-loading-card-grid [count]="2"></skeleton-loading-card-grid>
                        </div>
                        <p *ngIf="workOrderCompetenciesError" class="small-data d-block mb-2 text-danger">
                          Could not load work order competencies
                        </p>
                        <ng-container *ngIf="!workOrderCompetenciesLoading && !workOrderCompetenciesError && workOrderCompetencies.length">
                        <div class="competencies-content mt-5">
                          <div class="mb-4">
                            <div class="competency-section-header">
                              <p><i class="fas fa-user"></i> Lead Worker</p>
                            </div>
                            <div class="sl-accordion-content-overflow-wrapper">
                              <div class="competency-card-grid">
                                <competency-card
                                  *ngFor="let competency of leadWorkerCompetencies"
                                  [competency]="competency"
                                  cardType="work-order-readonly">
                                </competency-card>
                              </div>
                            </div>
                          </div>

                          <div class="mt-5">
                            <div class="competency-section-header">
                              <p><i class="fas fa-users"></i> All Workers</p>
                            </div>
                            <div class="sl-accordion-content-overflow-wrapper">
                              <div class="competency-card-grid">
                                <competency-card
                                  *ngFor="let competency of allWorkerCompetencies"
                                  [competency]="competency"
                                  cardType="work-order-readonly">
                                </competency-card>
                              </div>
                            </div>
                          </div>
                        </div>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="isSiteSession">
                      <span class="badge badge-pill badge-primary">Site Session</span>
                    </ng-container>
                  </sl-accordion-section>

                  <div class="check-in-section-divider" aria-hidden="true">
                    <span>Workers</span>
                  </div>

                  <sl-accordion-section title='Workers'>
                    <ng-container *ngIf="this.selectedWorkers.length">
                      <div>
                        <a href="javascript:void(0)" (click)="editSelectedWorkers()">change</a>
                      </div>
                      <br>
                    </ng-container>
                    <div *ngIf="!selectedWorkers.length">
                      <button type="button" class="btn btn-round btn-sm btn-primary" (click)="editSelectedWorkers()" [disabled]="isSiteLoading">Choose</button>
                      <span *ngIf="isSiteLoading" class="small-spinner-inline">
                        <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                      </span>
                    </div>

                    <div *ngFor="let worker of selectedWorkers; let i = index;">
                      <div class="form-group" *ngIf="workOrder && !isSiteSession && (workOrder.status !== 'OPEN')">
                        <p-radioButton
                            label="Lead Worker?"
                            name="leadWorkerIndex"
                            [value]="i"
                            [(ngModel)]="leadWorkerIndex"
                        ></p-radioButton>
                      </div>
                      <div>{{ worker.workerUser.firstName }} {{ worker.workerUser.lastName }}</div>
                      <div>{{ worker.workerUser.login }}</div>
                      <div>{{ worker.workerUser.workerUser.maintenance.name }}</div>
                      <dl class="sideways-dl worker-sideways-dl">
                        <div>
                          <dt>Competencies</dt>
                          <dd>
                            <ng-container *ngIf="worker.competenciesLoading; else workerCompetenciesKnown">
                              <skeleton-loading-card-grid [count]="2"></skeleton-loading-card-grid>
                            </ng-container>
                            <ng-template #workerCompetenciesKnown>
                              <span *ngIf="worker.competenciesError" class="small-data d-block mb-2 text-danger">Could not load competencies</span>
                              <div class="competency-card-grid" *ngIf="worker.competencies?.length; else emptyWorkerCompetencies">
                                <competency-card
                                  *ngFor="let item of worker.competencies"
                                  [competency]="item"
                                  cardType="user-readonly">
                                </competency-card>
                              </div>
                              <ng-template #emptyWorkerCompetencies>
                                <span *ngIf="!worker.competenciesError" class="d-block mb-2">No approved competencies</span>
                              </ng-template>
                            </ng-template>
                            <a href="javascript:void(0)" class="manage-competencies-link" (click)="goToCompetencies(worker)">
                              <i class="fa fa-external-link-alt" aria-hidden="true"></i>
                              Manage competencies
                            </a>
                          </dd>
                        </div>
                        <div>
                          <dt>Asset Categories</dt>
                          <dd>
                            <span *ngFor="let item of worker.assetCategories" class="badge badge-pill badge-success" [ngStyle]="{ 'background-color': item.color }">{{ item.name }}<br /></span>
                          </dd>
                        </div>
                        <div>
                          <dt>Induction</dt>
                          <dd>
                            <ng-container *ngIf="selectedSite?.siteInductionCourse">
                              <span *ngIf="worker.inductionForSite && worker.inductionForSite.courseProgress === TrainingCourseStateType.Completed" class="badge badge-pill badge-success">valid until: {{ worker.inductionForSite.expiryDate | date : 'mediumDate' }}</span>
                              <span *ngIf="worker.inductionForSite && worker.inductionForSite.courseProgress === TrainingCourseStateType.Expired" class="badge badge-pill badge-warning">expired on: {{ worker.inductionForSite.expiryDate | date : 'mediumDate' }}</span>
                              <span *ngIf="!worker.inductionForSite" class="badge badge-pill badge-danger">Not Verified</span>
                            </ng-container>
                          </dd>
                        </div>
                        <div *ngIf="!worker.workerUser.activated">
                          <dt>Activated</dt>
                          <dd>
                            <span *ngIf="!worker.inductionForSite" class="badge badge-pill badge-danger">Not activated</span>
                          </dd>
                        </div>
                      </dl>
                      <hr *ngIf="i < selectedWorkers.length - 1">
                    </div>
                  </sl-accordion-section>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-md-12">
                  <form [formGroup]="checkOnForm">
                    <div class="check-in-section-divider check-in-section-divider--form" aria-hidden="true">
                      <span>Check-in details</span>
                    </div>

                    <!-- Scheduling -->
                    <ng-container *ngIf="!checkOnForm.value.isSiteSession && allowAssetScheduling && checkOnForm.value.workOrder">
                      <div class="row text-center" *ngIf="checkOnForm.value.workOrder.asset.exemptFromAssetScheduling">
                        <div class="col-md-12">
                          <div class="alert alert-secondary" role="alert">Asset exempt from schedule</div>
                        </div>
                      </div>

                      <div class="row text-center" *ngIf="!checkOnForm.value.workOrder.asset.exemptFromAssetScheduling && checkOnForm.value.workOrder.exemptFromAssetScheduling">
                        <div class="col-md-12">
                          <div class="alert alert-secondary" role="alert">Work order exempt from schedule</div>
                        </div>
                      </div>

                      <div class="row" *ngIf="!checkOnForm.value.workOrder.asset.exemptFromAssetScheduling && !checkOnForm.value.workOrder.exemptFromAssetScheduling">
                        <div class="col-md-12">
                          <h6>Asset Schedule</h6>
                        </div>

                        <ng-container *ngIf="checkOnForm.value.workOrder.asset.assetAvailability.length">
                          <div class="col-md-12">
                            <div class="asset-schedule">
                              <div *ngFor="let row of checkOnForm.value.workOrder.asset.assetAvailability" class="asset-schedule-row">
                                <div class="asset-time">{{row.startTime | date: 'HH:mm'}} - {{row.endTime | date: 'HH:mm'}}</div>

                                <div class="asset-status">
                                  <span [ngClass]="row.status === 'Available' ? 'badge badge-pill badge-primary' : ''">{{ row.status }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12" *ngIf="!assetScheduleSlotCurrentlyAvailable">
                            No available windows have been scheduled
                            <div class="form-group form-group-checkbox">
                              <label>Check on anyway?</label>
                              <p-checkbox class="form-control" formControlName="skipAssetAvailabilityCheck" binary="true"></p-checkbox>
                            </div>
                          </div>
                        </ng-container>

                        <ng-container *ngIf="checkOnForm.value.workOrder.asset && !checkOnForm.value.workOrder.asset.assetAvailability.length">
                          <div class="col-md-12">
                            No available windows have been scheduled
                            <div class="form-group form-group-checkbox">
                              <label>Check on anyway?</label>
                              <p-checkbox class="form-control" formControlName="skipAssetAvailabilityCheck" binary="true"></p-checkbox>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <!-- End Scheduling -->

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>Reason <span class="required-star">*</span></label>
                          <textarea type="text" class="form-control" formControlName="reason" binary="true"></textarea>
                        </div>
                      </div>
                      <div class="col-md-4 mt-3">
                        <div class="form-group">
                          <label>Expected Check-off Time <span class="required-star">*</span></label>
                          <p-calendar class="form-control" formControlName="checkOffTime" timeOnly="true" [minDate]="minDate"></p-calendar>
                        </div>
                      </div>
                      <div class="col-md-12" *ngIf="selectedWorkers[0]?.guestsPermitted && checkOnForm.value.isSiteSession">
                        <div class="form-group">
                          <lable>Guests</lable>
                          <input type="number" class="form-control" formControlName="guestCount" />
                        </div>
                      </div>
                    </div>
                  </form>
                  <p-footer>
                    <button type="button" [disabled]="isFormBeingSubmitted || !selectedWorkers.length || !checkOnForm.valid || !areCompetenciesKnown" (click)="onCheckOnFormSubmit()" class="my-2 btn btn-round btn-sm btn-success">Check In</button>
                  </p-footer>
                </div>

                <div class="col-md-12">
                  <ng-container *ngFor="let error of preemptiveErrorAlerts">
                    <p-messages [value]="[error]"></p-messages>
                  </ng-container>
                  <ng-container *ngFor="let error of errorAlerts">
                    <p-messages [value]="[error]"></p-messages>
                  </ng-container>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
